import { MediaBasicDataDto } from '@sr/dto';
import { LinkToMedia } from 'shared/ui/links/link-to-media';
import { Box, Typography } from '@mui/material';

type Props = {
  childrenMedia?: MediaBasicDataDto[];
}

const getLocationText = (media: MediaBasicDataDto) => {
  if (media.country && !media.region && !media.city) {
    return media.country.name || String(media.country);
  }
  if (media.region && !media.city) {
    return media.region.name || String(media.region);
  }
  if (media.city) {
    return media.city.name || String(media.city);
  }
  return 'Местоположение не указано';
};

export const ChildrenMediaList = ({ childrenMedia }: Props) => {
  if (!childrenMedia || childrenMedia.length === 0) {
    return (
      <Box>
        <Typography variant="h6">Дочерние СМИ</Typography>
        <Typography>Нет дочерних СМИ</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Дочерние СМИ:
      </Typography>
      {childrenMedia.map((item) => (
        <Box key={item.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <LinkToMedia media={item}>{item.name}</LinkToMedia>
          <Typography variant="body2" color="text.secondary">
            ({getLocationText(item)})
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
